module.exports = {
      id: "close-usage",
      viewBox: "0 0 14 14.001",
      url: "/" + "sprite-bc5ff1507898764e0c54e53c34039c01.svg#close",
      toString: function () {
        return this.url;
      }
    }